import { createReducer, on } from '@ngrx/store';
import * as fromDeliveryDates from '../actions/replacement.delivery.dates.action';
import { StateSlice } from '@core/helpers/state-slice';
import { DeliveryDates } from '@dgx-pr-spa/shared/util';

export type DeliveryDatesState = StateSlice<DeliveryDates>;

export const initialState: DeliveryDatesState = {
  data: {} as DeliveryDates,
  loaded: false,
  loading: false,
  error: null,
};

const offersReducer = createReducer(
  initialState,
  on(fromDeliveryDates.loadDeliveryDates, () => {
    return {
      ...initialState,
      loading: true,
    };
  }),
  on(fromDeliveryDates.loadDeliveryDatesSuccess, (state, { payload }) => {
    return {
      ...state,
      loading: false,
      loaded: true,
      data: payload,
    };
  }),
  on(fromDeliveryDates.loadDeliveryDatesFail, (_, { payload }) => {
    return {
      ...initialState,
      loaded: true,
      error: payload,
    };
  }),
  on(fromDeliveryDates.resetDeliveryDates, () => {
    return {
      ...initialState,
    };
  })
);

export function reducer(
  state: DeliveryDatesState | undefined,
  action: fromDeliveryDates.DeliveryDatesActions
) {
  return offersReducer(state, action);
}
